import ShoppinglistClient from './clients/ShoppinglistClient';
import Mustache from 'mustache';
import { debounce, displayErrorFeedbackMessage, displayInfoFeedbackMessage, displaySuccessFeedbackMessage,
    getTranslation, removeValue } from './utilities';
import CartClient from './clients/CartClient';
import createAboPaths from './abo-paths';

class Shoppinglist
{
    constructor()
    {
        this.shoppingListClient = new ShoppinglistClient();
        this.cartClient = new CartClient();

        this.data = [];

        this.table = undefined;
        this.itemTables = {};
        this.childRows = null;
        this.selectedRows = {};

        this.$itemTableTemplate = $('#shoppinglistItemTable').hide().clone(true);

        this.listTemplate = document.querySelector('#shoppinglistListTemplate').innerHTML;
        this.itemElementTemplate = document.querySelector('#shoppinglistItemElementTemplate').innerHTML;

        this.selector = '.js-shoppinglist';
        this.itemSelector = '.js-shoppinglist__item';
        this.setAsDefaultButtonSelector = '.js-shoppinglist__set-as-default';
        this.deleteButtonSelector = '.js-shoppinglist__delete-list';
        this.addToCartButtonSelector = '.js-shoppinglist__add-to-cart';
        this.quantitySelector = '.js-shoppinglist__quantity';
        this.createButtonSelector = '.js-shoppinglist__create';
        this.createInputSelector = '.js-shoppinglist__create-input';
        this.editNameButtonSelector = '.js-shoppinglist__edit';
        this.oldNameSelector = '.js-shoppinglist__old-name';
        this.isDefaultCheckboxSelector = '.js-shoppinglist__edit-is-default';
        this.editNameInputSelector = '.js-shoppinglist__edit-name';
    }

    init()
    {
        this.table = $(this.selector).DataTable({
            ajax: {
                url: this.shoppingListClient.uri,
                dataSrc: this.shoppingListClient.dataSrc,
                error: function(jqXHR)
                {
                    if (jqXHR.status == 404)
                    {
                        this.table.clear().draw();
                    }
                }.bind(this)
            },
            ordering: false,
            pageLength: 20,
            searching: false,
            lengthChange: false,
            language: this.datatableTexts(),
            columnDefs: [{
                targets: 0,
                orderable: false,
                render: function(data, type, row)
                {
                    return Mustache.render(this.listTemplate, { shoppinglistList: row });
                }.bind(this)
            }],
            drawCallback: function()
            {
                if (this.childRows)
                {
                    this.childRows.every(function()
                    {
                        this.nodes().to$()
                            .click();
                    });

                    // Reset childRows so loop is not executed each draw
                    this.childRows = null;
                }

                $('#shoppinglist thead').hide();
                $('#shoppinglistItemTable thead').hide();
                this.initEvents();
            }.bind(this),
            createdRow: function(row, data)
            {
                let $row = $(row);

                $row.attr('data-shoppinglist-id', data.id);
                $row.addClass('shoppinglist-list__item dt--shadow dt--bp dt--shadow-mobile js-shoppinglist__item ' +
                    'js-gtm-shoppinglist__list-head--open');
            }
        });
    }

    initEvents()
    {
        let self = this;

        $(this.createButtonSelector).off('click');
        $(this.createButtonSelector).on('click', function()
        {
            self.handleCreateButtonClick(self.table.data().count());
        });

        $(this.editNameButtonSelector).off('click');
        $(this.editNameButtonSelector).on('click', function()
        {
            let $tr = $(this);
            let row = self.table.row($tr.parents(self.itemSelector));
            let data = row.data();

            self.showOverlay(data, $('#overlay-edit-shoppinglist'));
        });

        $(this.setAsDefaultButtonSelector).off('click');
        $(this.setAsDefaultButtonSelector).on('click', function()
        {
            let $tr = $(this);
            let row = self.table.row($tr.parents(self.itemSelector));
            let data = row.data();

            self.handleSetAsDefaultClick(data);
        });

        $(this.deleteButtonSelector).off('click');
        $(this.deleteButtonSelector).on('click', function()
        {
            let $tr = $(this);
            let row = self.table.row($tr.parents(self.itemSelector));
            let data = row.data();

            self.showOverlay(data, $('#overlay-delete-shoppinglist'));
        });

        $(this.addToCartButtonSelector).off('click');
        $(this.addToCartButtonSelector).on('click', function()
        {
            let $tr = $(this);
            let row = self.table.row($tr.parents(self.itemSelector));
            let data = row.data();

            let cartQuantity = $('#basket-onsite').data('cart-quantity');

            if (cartQuantity === 0)
            {
                self.handleAddListToCartClick(data);
            }
            else
            {
                self.showOverlay(data, $('#overlay-shoppinglist-to-cart'));
            }
        });

        $(this.selector).off('click');
        $(this.selector).on('click', this.itemSelector, function(e)
        {
            let $tr = $(this);
            let row = self.table.row($tr);
            let data = row.data();

            self.handleItemClick(e, $tr, row, data);
        });
    }

    handleItemClick(e, $tr, row, data)
    {
        if (e === null
			|| !$(e.target).hasClass('js-do-not-toggle-list')
			&& !$(e.target).parents('.js-do-not-toggle-list').length
        )
        {
            this.toggleDetail($tr, row, data);
            this.childRows = this.table.rows($('.shown'));
        }
    }

    datatableTexts()
    {
        return {
            'paginate': {
                'previous': '<i class="fa-regular fa-chevron-left p3"></i>',
                'next': '<i class="fa-regular fa-chevron-right p3"></i>',
            },
            'processing': getTranslation('content.shoppinglist.processing'),
            'loadingRecords': getTranslation('content.shoppinglist.loading'),
            'info': getTranslation('content.shoppinglist.info.entries'),
            'infoEmpty': getTranslation('content.shoppinglist.info.entries.empty'),
            'emptyTable': getTranslation('content.shoppinglist.info.list.empty'),
            'select': {
                'rows': {
                    _: '(%d) '
						+ getTranslation('content.shoppinglist.info.selected.article'),
                },
            }
        };
    }

    initChildEvents()
    {
        $(this.selector).off('input', this.quantitySelector);
        $(this.selector).on('input', this.quantitySelector, event =>
        {
            if (Number.parseInt(event.target.value) <= 0)
            {
                event.target.value = 1;
            }
        });

        $(this.selector).off('blur', this.quantitySelector);
        $(this.selector).on('blur', this.quantitySelector, event =>
        {
            if (event.target.value === '')
            {
                event.target.value = 1;
            }
        });

        $(this.selector).off('change', this.quantitySelector);
        $(this.selector).on('change', this.quantitySelector, debounce((event) =>
        {
            let $qtyInput = $(event.target);

            let shoppinglistId = $qtyInput.data('shoppinglist-id');
            let productNumber = $qtyInput.data('product-id');
            let quantity = $qtyInput.val();

            this.handleQtyChange(productNumber, quantity, shoppinglistId);
        }));
    }

    handleQtyChange(productNumber, quantity, shoppinglistId)
    {
        let data = {
            'productItems': [
                {
                    'productNumber': productNumber.toString(),
                    'quantity': Number.parseInt(quantity)
                }
            ]
        };

        this.handleRequestPromise(
            this.shoppingListClient.updateItems(data, shoppinglistId),
            '',
            '',
            false,
            this.itemTables[shoppinglistId],
            () =>
            {
                this.updateTableData(shoppinglistId);
            }
        );
    }

    disableFooterButtons(shoppinglistId)
    {
        if (!this.itemTables[shoppinglistId])
        {
            return;
        }

        this.itemTables[shoppinglistId].buttons().containers()
            .find('.js-shoppinglist__footer-btn-grp')
            .addClass('disabled');
    }

    enableFooterButtons(shoppinglistId)
    {
        if (!this.itemTables[shoppinglistId])
        {
            return;
        }

        this.itemTables[shoppinglistId].buttons().containers()
            .find('.js-shoppinglist__footer-btn-grp')
            .removeClass('disabled');
    }

    updateTableData(shoppinglistId)
    {
        if (!this.itemTables[shoppinglistId])
        {
            return;
        }

        this.disableFooterButtons(shoppinglistId);

        let $tr = $(this.itemTables[shoppinglistId].table().container()).parents('tr')
            .prev();
        let row = this.table.row($tr);
        let data = row.data();

        this.shoppingListClient.fetchShoppinglist(shoppinglistId)
            .then((response) => response.json())
            .then((shoppinglistData) =>
            {
                data.grandTotalString = shoppinglistData.grandTotalString;
                data.productItemCount = shoppinglistData.productItemCount;

                row.data(data);

                this.itemTables[shoppinglistId].draw();
            });
    }

    updateCsvButton(button, data)
    {
        if (data.productItemCount === 0)
        {
            button.addClass('disabled');
        }
    }

    formatOrder(self, order)
    {
        $(order).each(function(k)
        {
            order[k].field = self.matchOrderIdWithColumnName(order[k].column);
        });

        return order;
    }

    matchOrderIdWithColumnName(orderId)
    {
        switch (orderId)
        {
        case 1:
            return 'productNumber';
        case 2:
            return 'productName';
        case 3:
            return 'undiscountedPrice';
        case 4:
            return 'suggestedRetailPrice';
        case 5:
            return 'discountedPrice';
        case 6:
            return 'quantity';
        case 7:
            return 'subtotalPrice';
        default:
            return null;
        }
    }

    createChildTable(row, shoppinglistId)
    {
        let self = this;
        let template = this.$itemTableTemplate.show().clone(true);
        let isEmpty;

        row.child(template).show();

        let itemTable = template.DataTable({
            ajax: {
                url: this.shoppingListClient.uri + '/' + shoppinglistId + '/items',
                data: function(data)
                {
                    return {
                        draw: data.draw,
                        skip: data.start,
                        take: data.length,
                        sort: self.formatOrder(self, data.order)// data.order
                    };
                },
                dataSrc: function(json)
                {
                    return json.response.productItems.map((productItem) =>
                    {
                        const originalSrc = productItem.productImageUrl.trim();
                        const targetSrc = originalSrc.replace('product-main-image', 'product-list-image-thumbnail');

                        const aboPaths = createAboPaths(targetSrc);

                        productItem.productImageUrl = aboPaths.original;
                        productItem.productImageUrlAvif = aboPaths.avifImage + ', ' + aboPaths.avifRetinaImage + ' 2x';
                        productItem.productImageUrlWebp = aboPaths.webPImage + ', ' + aboPaths.webPRetinaImage + ' 2x';
                        productItem.productImageUrlJpeg = aboPaths.jpgImage + ', ' + aboPaths.jpgRetinaImage + ' 2x';

                        productItem.noveltyFlag = productItem.noveltyFlag !== '0';
                        productItem.bestsellerFlag = productItem.bestsellerFlag !== 0;
                        productItem.expiringProductFlag = productItem.expiringProductFlag !== 0;
                        productItem.promotionalPackingFlag = productItem.promotionalPackingFlag === 0;
                        productItem.privateBrandFlag = productItem.privateBrandFlag !== 0;
                        productItem.bargainProductFlag = productItem.bargainProductFlag !== 0;
                        productItem.posProductFlag = productItem.posProductFlag !== '0';
                        productItem.discountBlock = productItem.discountBlock === 'true';

                        productItem.isOutOfStock = false;
                        productItem.isAvailable = false;
                        productItem.isUpcoming = false;

                        if (productItem.availability === 0)
                        {
                            productItem.isOutOfStock = true;
                        }
                        else if (productItem.availability === 1)
                        {
                            productItem.isAvailable = true;
                        }
                        else if (productItem.availability === 2)
                        {
                            productItem.isUpcoming = true;
                        }

                        return productItem;
                    });
                }
            },
            dom: 'l\
				f\
				r\
				<"shoppinglist-table__scroll"t>\
				<"shoppinglist__action-wrapper"\
				<"shoppinglist-actions__selection">\
				<"shoppinglist-actions__pagination"pi>\
				<"shoppinglist-actions__basket">>',
            pageLength: 20,
            rowId: 'productNumber',
            serverSide: true,
            processing: true,
            // order: [[2, 'asc']],
            language: this.datatableTexts(),
            searching: false,
            lengthChange: false,
            columnDefs: [
                {
                    targets: 0,
                    className: 'shoppinglist-list__select select-checkbox',
                    orderable: false,
                    render: function(data)
                    {
                        return Mustache.render(this.itemElementTemplate, {
                            shoppinglistListItem: data,
                            selectColumn: true
                        });
                    }.bind(this)
                },
                {
                    // Hidden column to sort for product number
                    // Sort criteria must be mapped to a column
                    // See matchOrderIdWithColumnName(orderId)
                    targets: 1,
                    visible: false,
                    render: function()
                    {
                        return Mustache.render(this.itemElementTemplate, {
                            productNumberColumn: true
                        });
                    }.bind(this)
                },
                {
                    data: null,
                    targets: 2,
                    orderable: false,
                    className: 'shoppinglist-list__product-details',
                    render: function(data, type, row)
                    {
                        return Mustache.render(this.itemElementTemplate, {
                            shoppinglistListItem: row,
                            productDetailsColumn: true
                        });
                    }.bind(this),
                    createdCell: function(td, _cellData, rowData)
                    {
                        let $cell = $(td);
                        let $availability = $cell.find('i');

                        if (rowData.isOutOfStock)
                        {
                            $availability.addClass('out-of-stock');
                        }
                        else if (rowData.isAvailable)
                        {
                            $availability.addClass('in-stock');
                        }
                        else if (rowData.isUpcoming)
                        {
                            $availability.addClass('out-of-stock');
                        }
                    }
                },
                {
                    targets: 3,
                    orderable: false,
                    className: 'shoppinglist-list__lp-sp',
                    render: function(data, type, row)
                    {
                        return Mustache.render(this.itemElementTemplate, {
                            shoppinglistListItem: row,
                            undiscountedPriceColumn: !row.productUnknown
                        });
                    }.bind(this)
                },
                {
                    targets: 4,
                    orderable: false,
                    className: 'shoppinglist-list__srp',
                    render: function(data, type, row)
                    {
                        return Mustache.render(this.itemElementTemplate, {
                            shoppinglistListItem: row,
                            suggestedRetailPriceColumn: !row.productUnknown
                        });
                    }.bind(this)
                },
                {
                    targets: 5,
                    orderable: false,
                    className: 'shoppinglist-list__price',
                    render: function(data, type, row)
                    {
                        return Mustache.render(this.itemElementTemplate, {
                            shoppinglistListItem: row,
                            discountedPriceColumn: !row.productUnknown
                        });
                    }.bind(this)
                },
                {
                    targets: 6,
                    orderable: false,
                    className: 'shoppinglist-list__quantity tooltip-wrapper',
                    render: function(data, type, row)
                    {
                        return Mustache.render(this.itemElementTemplate, {
                            shoppinglistListItem: row,
                            shoppingListId: shoppinglistId,
                            quantityColumn: !row.productUnknown && row.availability !== 2
                        });
                    }.bind(this)
                },
                {
                    data: 'subtotalPrice',
                    targets: 7,
                    orderable: false,
                    className: 'shoppinglist-list__total',
                    render: function(data, type, row)
                    {
                        return Mustache.render(this.itemElementTemplate, {
                            shoppinglistListItem: row,
                            subtotalPriceColumn: !row.productUnknown
                        });
                    }.bind(this)
                }
            ],
            select: {
                style: 'multi',
                selector: 'td:first-child'
            },
            drawCallback: function()
            {
                let $tr = $(this).parents('tr');
                let row = self.table.row($tr.prev());
                let data = row.data();

                isEmpty = itemTable.data().count() === 0;

                $tr.addClass('shoppinglist-list__item-table dt--shadow');

                if (isEmpty)
                {
                    $tr.find('#shoppinglistItemTable_wrapper').empty().append($(this).find('.dataTables_empty'));
                }
                else
                {
                    $('#shoppinglistItemTable thead').show();
                    $('#shoppinglistItemTable').eq(0)
                        .hide();

                    if (self.selectedRows
						&& self.selectedRows[shoppinglistId]
						&& self.selectedRows[shoppinglistId].length > 0)
                    {
                        self.selectedRows[shoppinglistId].forEach((productNumber) =>
                        {
                            itemTable.row('#' + productNumber).select();
                        });


                        self.enableFooterButtons(shoppinglistId);
                    }
                    else
                    {
                        self.disableFooterButtons(shoppinglistId);
                    }

                    let $csvButton = $tr
                        .find('.js-shoppinglist__download-csv');

                    self.updateCsvButton($csvButton, data);

                    $('.js-shoppinglist__grand-total').remove();
                    $tr.find('#shoppinglistItemTable_wrapper').append(
                        '<span class="grand-total js-shoppinglist__grand-total">'
						+ getTranslation('content.shoppinglist.detail.sum')
						+ ' '
						+ data.grandTotalString
						+ '</span>'
                    );
                }

                self.initEvents();
            },
            initComplete: function()
            {
                let $tr = $(this).parents('tr');
                let row = self.table.row($tr.prev());
                let data = row.data();

                if (!isEmpty)
                {
                    self.initChildEvents();

                    itemTable.buttons('checkbox', null).container()
                        .appendTo($tr.find('.js-shoppinglist__select_all'));

                    itemTable.buttons('selection', null).container()
                        .appendTo($tr.find('.shoppinglist-actions__selection'));

                    itemTable.buttons('basket', null).container()
                        .appendTo($tr.find('.shoppinglist-actions__basket'));

                    $('.dataTables_paginate').addClass('shoppinglist_pagination');
                    self.itemTables[shoppinglistId] = itemTable;

                    self.createSortSelection(itemTable, this[0]);

                    let $csvButton = $tr.find('.csv-cell');

                    $csvButton.data('uid', data.id);
                    $csvButton.data('listName', data.name);

                    self.updateCsvButton($csvButton, data);

                    $('body').trigger(orion.constants.EventCsvDownloadButtonAppended);
                    $('body').trigger(orion.constants.EventProductListReloaded);
                }
            }
        });

        new $.fn.dataTable.Buttons(itemTable, {
            name: 'checkbox',
            buttons: [
                {
                    action: function(e)
                    {
                        let checkbox = e.target.closest('th');

                        if (!checkbox.classList.contains('selected'))
                        {
                            this.shoppingListClient.fetchAllItems(shoppinglistId)
                                .then((response) => response.json())
                                .then((body) =>
                                {
                                    this.selectedRows[shoppinglistId] = Object.keys(body);
                                });
                            checkbox.classList.add('selected');
                            itemTable.rows().select();
                            itemTable.draw(false);
                        }
                        else
                        {
                            this.selectedRows[shoppinglistId] = [];
                            checkbox.classList.remove('selected');
                            itemTable.rows().deselect();
                            itemTable.draw(false);
                        }
                    }.bind(this)
                }
            ]
        });

        new $.fn.dataTable.Buttons(itemTable, {
            name: 'selection',
            buttons: [
                {
                    text: '<i class="fa-regular fa-trash-can"></i> '
						+ '<span>'
						+ getTranslation('content.shoppinglist.delete~selection')
						+ '</span>',
                    className: 'js-shoppinglist__delete_selected js-gtm-shoppinglist__list-body--delete ' +
                        'js-shoppinglist__footer-btn-grp secondary disabled',
                    action: function(e)
                    {
                        let $tr = $(e.target).parents('tr');
                        let row = this.table.row($tr.prev());
                        let data = row.data();
                        let selectedItems = this.selectedRows[shoppinglistId];

                        $('.js-shoppinglist-delete-products-count').text(selectedItems.length);

                        if (selectedItems.length > 1)
                        {
                            $('.js-overlay-delete-shoppinglist-products-singular').addClass('hidden');
                            $('.js-overlay-delete-shoppinglist-products-plural').removeClass('hidden');
                        }
                        else
                        {
                            $('.js-overlay-delete-shoppinglist-products-singular').removeClass('hidden');
                            $('.js-overlay-delete-shoppinglist-products-plural').addClass('hidden');
                        }

                        this.showOverlay(data, $('#overlay-delete-shoppinglist-products'), selectedItems);
                    }.bind(this)
                },
                {
                    text:  '<i class="fa-regular fa-download"></i> '
						+ '<span>'
						+ getTranslation('form.download-shoppinglist-as-csv')
						+ '</span>',
                    className: 'csv-cell js-shoppinglist__download-csv js-gtm-shoppinglist__list-body--csv ' +
                        'js-download-shoppinglist-as-csv download-shoppinglist-as-csv secondary',
                }
            ]
        });

        new $.fn.dataTable.Buttons(itemTable, {
            name: 'basket',
            buttons: [
                {
                    text: '<i class="fa-regular fa-shopping-cart"></i> '
						+ '<span>'
						+ getTranslation('content.shoppinglist.selection.to.basket')
						+ '</span>',
                    className: 'shoppinglist_button__selection-to-basket ' +
                        'js-gtm-shoppinglist__list-body-to-basket--open buy--button ' +
                        'js-shoppinglist__footer-btn-grp disabled',
                    action: function(e)
                    {
                        let $tr = $(e.target).parents('tr');
                        let row = this.table.row($tr.prev());
                        let data = row.data();

                        this.handleShoppingListChoiceAddToCartClick(data, this.selectedRows[shoppinglistId]);
                    }.bind(this)
                }
            ]
        });

        itemTable.on('select', ( e, dt, type, indexes ) =>
        {
            if (!$(e.target).is('.js-shoppinglist__quantity'))
            {
                let { 0: productNumber } = itemTable.rows(indexes).data().pluck('productNumber');

                if (!this.selectedRows || typeof this.selectedRows[shoppinglistId] === 'undefined')
                {
                    this.selectedRows[shoppinglistId] = [];
                }

                if (!this.selectedRows[shoppinglistId].includes(productNumber))
                {
                    this.selectedRows[shoppinglistId].push(productNumber);
                }

                if (this.selectedRows[shoppinglistId].length > 0)
                {
                    this.enableFooterButtons(shoppinglistId);
                }
            }
        });

        itemTable.on('deselect', ( e, dt, type, indexes ) =>
        {
            if (!this.selectedRows || typeof this.selectedRows[shoppinglistId] === 'undefined')
            {
                this.selectedRows[shoppinglistId] = [];
            }

            let { 0: productNumber } = itemTable.rows(indexes).data().pluck('productNumber');

            this.selectedRows[shoppinglistId] = removeValue(this.selectedRows[shoppinglistId], productNumber);

            if (this.selectedRows[shoppinglistId].length === 0)
            {
                this.disableFooterButtons(shoppinglistId);
            }
        });
    }

    createSortSelection(itemTable, currentTable)
    {
        let filterSection = document.createElement('div');
        let sortSelection = document.createElement('select');
        let sortPlaceholder = document.createElement('option');

        filterSection.classList.add('shoppinglist-list__sort', 'select-button-container');
        sortSelection.classList.add('js-gtm-shoppinglist__list-body--sort');

        sortPlaceholder.value = '';
        sortPlaceholder.text = getTranslation('content.shoppinglist.child.sort.recent');
        sortPlaceholder.selected;
        sortPlaceholder.disabled;
        sortSelection.appendChild(sortPlaceholder);

        let { 0: columns } = itemTable.columns();

        const srpColumnId = 4;

        for (let i = 1; i < columns.length; i++)
        {
            if (i === srpColumnId)
            {
                continue;
            }

            let optionAscending = document.createElement('option');
            let optionDescending = document.createElement('option');

            optionAscending.value = columns[i];
            optionAscending.text = getTranslation('content.shoppinglist.child.header.col.' + i) + ' '
                + getTranslation('content.shoppinglist.child.sort.ascending');
            sortSelection.appendChild(optionAscending);

            optionDescending.value = columns[i] * -1;
            optionDescending.text = getTranslation('content.shoppinglist.child.header.col.' + i) + ' '
                + getTranslation('content.shoppinglist.child.sort.descending');
            sortSelection.appendChild(optionDescending);
        }

        filterSection.append(sortSelection);
        $(filterSection).prependTo($(currentTable).closest('#shoppinglistItemTable_wrapper'));

        sortSelection.addEventListener('change', function()
        {
            if (this.value > 0)
            {
                itemTable.order([this.value, 'asc']).draw();
            }
            else if (this.value < 0)
            {
                itemTable.order([this.value * -1, 'desc']).draw();
            }
            else
            {
                itemTable.order([0, 'asc']).draw();
            }
        });
    }

    handleCreateButtonClick(shoppinglistCount)
    {
        let feedbackMessage = $('#feedback-shoppinglist-new-ok').text();
        let name = $(this.createInputSelector).val();

        if (name === '')
        {
            name = $(this.createInputSelector).attr('placeholder');
        }

        let newData = {
            'name': name,
            'isDefault': shoppinglistCount === 0
        };

        let promise = this.shoppingListClient.createShoppinglist(newData);

        this.handleRequestPromise(promise, feedbackMessage, '', true);
    }

    handleSetAsDefaultClick(data)
    {
        let newData = {
            'isDefault': true,
            'name': data.name
        };

        let feedbackMessage = $('#feedback-shoppinglist-delete-new-default-list').text();
        let successMessage = feedbackMessage.replace(/%s/g, data.name);

        let promise = this.shoppingListClient.update(newData, data.id);

        this.handleRequestPromise(promise, successMessage, '', true);
    }

    handleEditShoppingListClick(data)
    {
        let promise = this.shoppingListClient.update(data, data.id);

        this.handleRequestPromise(promise, '', '', true);
    }

    handleDeleteListClick(data)
    {
        let successMessage = $('#feedback-shoppinglist-delete-ok').text();

        let promise = this.shoppingListClient.deleteShoppinglist(data.id);

        this.handleRequestPromise(promise, successMessage, '', true);
    }

    handleAddListToCartClick(data)
    {
        let successMessage = $('#feedback-shoppinglist-add-to-cart-ok').text();
        let errorMessage = $('#feedback-shoppinglist-add-to-cart-failed').text();

        let promise = this.shoppingListClient.addToCart(data.id);

        let cb = () =>
        {
            this.createToCartFeedback(
                promise,
                successMessage,
                errorMessage,
                data.productItemCount
            );
        };

        this.handleRequestPromise(
            promise,
            '',
            '',
            false,
            this.table,
            cb
        );
    }

    handleAddItemsToCartClick(data, selectedItems)
    {
        let successMessage = $('#feedback-shoppinglist-add-to-cart-choice-ok').text();
        let errorMessage = $('#feedback-shoppinglist-add-to-cart-choice-failed').text();

        let promise = this.shoppingListClient.addItemsToCart(selectedItems, data.id);

        let cb = () =>
        {
            this.createToCartFeedback(
                promise,
                successMessage,
                errorMessage,
                selectedItems.productItems.length
            );
        };

        this.handleRequestPromise(
            promise,
            '',
            '',
            false,
            this.table,
            cb
        );
    }

    handleReplaceCartClick(data)
    {
        let successMessage = $('#feedback-shoppinglist-replace-cart-ok').text();
        let errorMessage = $('#feedback-shoppinglist-replace-cart-failed').text();

        let promise = this.shoppingListClient.replaceCart(data.id);

        let cb = () =>
        {
            this.createToCartFeedback(
                promise,
                successMessage,
                errorMessage,
                data.productItemCount
            );
        };

        this.handleRequestPromise(
            promise,
            '',
            '',
            false,
            this.table,
            cb
        );
    }

    handleReplaceCartWithSelectionClick(data, selectedItems)
    {
        let successMessage = $('#feedback-shoppinglist-replace-cart-choice-ok').text();
        let errorMessage = $('#feedback-shoppinglist-replace-cart-choice-failed').text();

        let listItems = this.itemTables[data.id].rows().data().toArray();
        let upcomingItemsCount = 0;
        let unknownItemsCount = 0;

        selectedItems.productItems.forEach(selectedItem =>
        {
            let itemData = listItems.find(listItem => listItem.productNumber === selectedItem.productNumber);

            if (itemData.isUpcoming)
            {
                upcomingItemsCount += 1;
            }

            if (itemData.productUnknown)
            {
                unknownItemsCount += 1;
            }
        });

        if (selectedItems.productItems.length > upcomingItemsCount + unknownItemsCount)
        {
            this.cartClient.delete().then(() =>
            {
                let promise = this.shoppingListClient.addItemsToCart(selectedItems, data.id);

                let cb = () =>
                {
                    this.createToCartFeedback(
                        promise,
                        successMessage,
                        errorMessage,
                        selectedItems.productItems.length
                    );
                };

                this.handleRequestPromise(
                    promise,
                    '',
                    '',
                    false,
                    this.table,
                    cb
                );
            });
        }
        else
        {
            let promise = this.shoppingListClient.addItemsToCart(selectedItems, data.id);

            this.createToCartFeedback(promise, successMessage, errorMessage, selectedItems.productItems.length);
        }
    }

    handleShoppingListChoiceAddToCartClick(data, selectedData)
    {
        let items = this.productNumbersArrayToBodyData(selectedData);
        let cartQuantity = $('#basket-onsite').data('cart-quantity');

        if (cartQuantity === 0)
        {
            let successMessage = $('#feedback-shoppinglist-add-to-cart-choice-ok').text();
            let errorMessage = $('#feedback-shoppinglist-add-to-cart-choice-failed').text();

            let promise = this.shoppingListClient.addItemsToCart(items, data.id);

            let cb = () =>
            {
                this.createToCartFeedback(
                    promise,
                    successMessage,
                    errorMessage,
                    selectedData.length
                );
            };

            this.handleRequestPromise(
                promise,
                '',
                '',
                false,
                this.table,
                cb
            );
        }
        else
        {
            this.showOverlay(data, $('#overlay-shoppinglistitems-to-cart'), items);
        }
    }

    handleShoppingListChoiceDeleteClick(data, selectedData)
    {
        let items = this.productNumbersArrayToBodyData(selectedData);
        let successMessage = $('#feedback-shoppinglist-delete-choices-ok').text();

        let promise = this.shoppingListClient.deleteItems(items, data.id);

        this.handleRequestPromise(
            promise,
            successMessage,
            '',
            true,
            this.itemTables[data.id],
            () =>
            {
                this.updateTableData(data.id);
            }
        );

        selectedData.forEach((productNumber) =>
        {
            this.selectedRows[data.id] = removeValue(this.selectedRows[data.id], productNumber);
        });
    }

    createToCartFeedback(promise, successMessage, errorMessage, productItemCount)
    {
        promise.then((response) => response.json()).then((data) =>
        {
            if (data.upcomingProducts.length + data.unknownProducts.length < productItemCount)
            {
                displaySuccessFeedbackMessage(successMessage);
            }
            else
            {
                displayErrorFeedbackMessage(errorMessage);
            }

            if (data.upcomingProducts.length)
            {
                displayInfoFeedbackMessage(this.createBlockedProductsFeedback('upcoming', data.upcomingProducts));
            }

            if (data.unknownProducts.length)
            {
                displayErrorFeedbackMessage(this.createBlockedProductsFeedback('unknown', data.unknownProducts));
            }
        });
    }

    createBlockedProductsFeedback(type, productNumbers)
    {
        let feedbackSelector =
            `meta[name='content.shoppinglist.add.to.cart.${type}.products']`;
        let feedbackMessage = document.querySelector(feedbackSelector).content;
        let productsString = '';

        productNumbers.forEach((productNumber, index) =>
        {
            productsString += (index === 0 ? productNumber : ', ' + productNumber);
        });

        feedbackMessage = feedbackMessage.replace('%s', productsString);

        return feedbackMessage;
    }

    productNumbersArrayToBodyData(productNumbers)
    {
        let productItems = [];

        productNumbers.forEach((productNumber) =>
        {
            productItems.push({
                'productNumber': productNumber
            });
        });

        return {
            'productItems': productItems
        };
    }

    /**
	 * @param promise {Promise<Response>}
	 * @param successMessage {string}
	 * @param errorMessage {string}
	 * @param refreshAfterSuccess {boolean}
	 * @param tableRef
	 * @param cb
	 */
    handleRequestPromise(
        promise,
        successMessage,
        errorMessage = '',
        refreshAfterSuccess = false,
        tableRef = this.table,
        cb = null
    )
    {
        promise
            .then(function()
            {
                this.handleErrorRequests(errorMessage);
            }.bind(this))
            .then(function()
            {
                this.handleSuccessfulRequests(successMessage, refreshAfterSuccess, tableRef);
                $('body').trigger(orion.constants.EventCartProductUpdated);
                if (typeof cb === 'function')
                {
                    cb();
                }
            }.bind(this))
            .catch(function(error)
            {
                // eslint-disable-next-line no-console
                console.error(error);
            });
    }

    /**
	 * @param successMessage {string}
	 * @param refreshAfter
	 * @param tableRef
	 */
    handleSuccessfulRequests(successMessage, refreshAfter, tableRef)
    {
        if (successMessage !== '')
        {
            displaySuccessFeedbackMessage(successMessage);
        }
        if (refreshAfter)
        {
            tableRef.ajax.reload(() =>
            {
                this.initEvents();
                this.initChildEvents();
            }, false);
        }
    }

    handleErrorRequests(errorMessage)
    {
        if (errorMessage !== '')
        {
            displayErrorFeedbackMessage(errorMessage);
        }
    }

    showOverlay(data, $overlay, selectedItems)
    {
        $overlay.unbind();
        let $body = $('body');

        $overlay.removeClass('hidden');
        $body.addClass('focus-active');

        $body.on('focus-overlay-clicked', () =>
        {
            this.hideOverlay($overlay);
        });
        $overlay.on('click', '.close, .close-overlay', () =>
        {
            this.hideOverlay($overlay);
        });
        $overlay.on('click', '.delete-shoppinglist', () =>
        {
            this.handleDeleteListClick(data);
            this.hideOverlay($overlay);
        });
        $overlay.on('click', '.js-delete-shoppinglist-products', () =>
        {
            this.handleShoppingListChoiceDeleteClick(data, selectedItems);
            this.hideOverlay($overlay);
        });
        $overlay.on('click', '.replace-cart', () =>
        {
            this.handleReplaceCartClick(data);
            this.hideOverlay($overlay);
        });
        $overlay.on('click', '.add-to-cart', () =>
        {
            this.handleAddListToCartClick(data);
            this.hideOverlay($overlay);
        });
        $overlay.on('click', '.replace-choice-in-cart', () =>
        {
            this.handleReplaceCartWithSelectionClick(data, selectedItems);
            this.hideOverlay($overlay);
        });
        $overlay.on('click', '.add-choice-to-cart', () =>
        {
            this.handleAddItemsToCartClick(data, selectedItems);
            this.hideOverlay($overlay);
        });

        if ($overlay.is('#overlay-edit-shoppinglist'))
        {
            let oldName = data.name;
            let [overlay] = $overlay;

            overlay.querySelector(this.oldNameSelector).innerHTML = oldName;
            // overlay.querySelector(this.editNameInputSelector).value = oldName shows html entities
            // As a workaround we insert overlay.querySelector(this.oldNameSelector).innerHTML
            overlay.querySelector(this.editNameInputSelector).value =
                overlay.querySelector(this.oldNameSelector).innerHTML;

            // Tue irgendwas mit der Checkbox
            overlay.querySelector(this.isDefaultCheckboxSelector).checked = data.isDefault;
            if (data.isDefault)
            {
                $overlay.find('.js-shoppinglist__is-default').removeClass( 'hidden' );
                $overlay.find('.js-default-checkbox-container').addClass( 'hidden' );
            }
            else
            {
                $overlay.find('.js-shoppinglist__is-default').addClass( 'hidden' );
                $overlay.find('.js-default-checkbox-container').removeClass( 'hidden' );
            }

            $overlay.on('click', '.js-edit-shoppinglist-save', () =>
            {
                let newName = overlay.querySelector(this.editNameInputSelector).value;
                let isDefault = overlay.querySelector(this.isDefaultCheckboxSelector).checked;

                if (data.name != newName || data.isDefault != isDefault)
                {
                    data.name = newName;
                    data.isDefault = isDefault;

                    this.handleEditShoppingListClick(data);
                }

                this.hideOverlay($overlay);
            });
        }
    }

    hideOverlay($overlay)
    {
        $overlay.addClass('hidden');
        $('body').removeClass('focus-active');
    }

    destroyChild(row)
    {
        let $table = $('table', row.child());

        $table.detach();
        $table.DataTable().destroy();

        // And then hide the row
        row.child.hide();
    }

    toggleDetail(tr, row, data)
    {
        if (row.child.isShown())
        {
            // This row is already open - close it
            row.child.hide();
            tr.removeClass('shown');
            tr.find('.js-expand-list-span').removeClass('open');
        }
        else
        {
            // Open this row
            if (typeof row.child() !== 'undefined')
            {
                row.child.show();
                tr.addClass('shown');
                tr.find('.js-expand-list-span').addClass('open');
            }
            else
            {
                this.createChildTable(row, data.id);
                tr.addClass('shown');
                tr.find('.js-expand-list-span').addClass('open');
            }
        }
    }
}

if (document.querySelector('.js-shoppinglist') !== null)
{
    (new Shoppinglist()).init();
}
